import React from 'react';
import '../../styles/Person.css';


const SelectedPublications = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      {/* 咨询和工作组 */}
      <div className="page style-link style-ul font-16px">
        <div className="heading-2 top-heading-margin">Selected Publications</div>
        <div className="decoration-line"></div>

        <div>
          <div className="style4">

            <div className="publication-category">AI Ethics, Safety, and Governance</div>
            <ul>
              <li><strong>Papers and Reports</strong></li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Guobin Shen, Dongcheng Zhao, Yiting Dong, Xiang He, Yi Zeng. <a href="https://arxiv.org/abs/2410.02298" target="_blank">Jailbreak Antidote: Runtime Safety-Utility Balance via Sparse Representation Adjustment in Large Language Models</a>.
                International Conference on Learning Representations (ICLR), 2025.
              </li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Guobin Shen, Dongcheng Zhao, Aorigele Bao, Xiang He, Yiting Dong, Yi Zeng. <a href="https://arxiv.org/abs/2409.17167" target="_blank">StressPrompt: Does Stress Impact Large Language Models and Human Performance Similarly?</a>. AAAI
                Conference on Artificial Intelligence (AAAI), 2025.
              </li>
            </ul>

            <ul>
              <li className="li-effect-before li-effect-after">Aorigele Bao, Yi Zeng. <a href="https://www.tandfonline.com/doi/abs/10.1080/08989621.2024.2420812" target="_blank">Allowing AI co-authors is a disregard for humanization</a>. Accountability in Research, 2024.</li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Yuwei Wang, Enmeng Lu, Zizhe Ruan, Yao Liang, Yi Zeng. <a href="https://link.springer.com/article/10.1007/s00146-023-01851-6" target="_blank">Stream: Social data and knowledge collective intelligence platform for TRaining Ethical AI
                Models</a>. AI & SOCIETY, 2024: 1-9.
              </li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Aorigele Bao, Yi Zeng. <a href="https://www.nature.com/articles/s41599-024-02759-2" target="_blank">Understanding the dilemma of explainable artificial intelligence: a proposal for a ritual dialog framework</a>. Humanities and Social
                Sciences Communications 11.1 (2024): 1-9.
              </li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Aorigele Bao, Yi Zeng. <a href="https://link.springer.com/article/10.1007/s10676-024-09744-y" target="_blank">Embracing grief in the age of deathbots: a temporary tool, not a permanent solution</a>. Ethics and Information Technology,
                2024, 26(1): 7.
              </li>
            </ul>

            <ul>
              <li className="li-effect-before li-effect-after">Yi Zeng, Enmeng Lu, Kang Sun. <a href="https://link.springer.com/article/10.1007/s43681-023-00364-8" target="_blank">Principles on symbiosis for natural life and living artificial intelligence.</a> AI and Ethics, 2023.</li>
            </ul>
            <ul>
              <li className="li-effect-before li-effect-after">Aorigele Bao, Yi Zeng, Enmeng Lu. <a href="https://www.nature.com/articles/s41599-023-02143-6" target="_blank">Mitigating emotional risks in human-social robot interactions through virtual interactive environment
                indication.</a> Humanities and Social Sciences Communications, Nature Press, 2023.
              </li>
            </ul>
            <ul>
              <li>Yi Zeng. <a href="https://ai-ethics-and-governance.institute/2022/03/22/deep-coordination-among-development-ethics-and-governance-of-science-and-technology/" target="_blank">Deep Coordination among Development, Ethics, and Governance of Science and Technology</a>. China Science
                Daily, March 22, 2022.
              </li>
            </ul>
            <ul>
              <li>Yi Zeng, Kang Sun, Enmeng Lu. <a href="https://link.springer.com/article/10.1007/s43681-020-00036-x" target="_blank">Declaration on the Ethics of Brain-Computer Interfaces and Augment Intelligence</a>. AI and Ethics, Springer, 2021.</li>
            </ul>
            <ul>
              <li>Yi Zeng. <a href="https://www.baai.ac.cn/news_article?content_id=62&type=news" target="_blank">Global Cooperation on Artificial Intelligence is not a Zero-Sum Game</a>.Guangming Daily, 2021.</li>
            </ul>
            <ul>
              <li>Yi Zeng, Kang Sun, Enmeng Lu. <a href="https://ifi.u-tokyo.ac.jp/en/wp-content/uploads/2020/09/report_200916.pdf" target="_blank">Ethics and Governance Perspectives to Fight Against Catastrophic Risks: From COVID-19 to Long-term Safety Issues of Artificial General Intelligence</a>.
                In: Data, AI Governance, and COVID-19: Medium and Long-term Perspectives for Asia, 2020 (This paper is originally published in Japanese in IPSJ Magazine, Vol. 61, No. 10, October 2020).
              </li>
            </ul>
            <ul>
              <li>Se&#225;n S. &#211;h&#201;igeartaigh, Jess Whittlestone, Yang Liu, Yi Zeng & Zhe Liu. <a href="https://link.springer.com/article/10.1007/s13347-020-00402-x" target="_blank"> Overcoming Barriers to Cross-cultural Cooperation in AI Ethics and Governance</a>. Philosophy & Technology,
                2020.
              </li>
            </ul>
            <ul>
              <li>Yi Zeng, Enmeng Lu, Kang Sun, Samuel Curtis. <a href="https://attachment.baai.ac.cn/share/aies/facial-recognition-and-public-health-en-2020-05-17.pdf" target="_blank"> Facial Recognition and Public Health</a>. Artificial Intelligence and Healthy Society Survey Series, Beijing
                Academy of Artificial Intelligence, 2020.
              </li>
            </ul>
            <ul>
              <li>Yi Zeng. <a href="http://www.ai-for-sdgs.academy/ai-as-an-accelerator-for-sdgs" target="_blank"> Artificial Intelligence: An Accelerator for United Nations Sustainable Development Goals</a>. Guangming Daily, June 18th, 2020.</li>
            </ul>
            <ul>
              <li>Yi Zeng, Kang Sun. <a href="https://www.globaltimes.cn/content/1181846.shtml" target="_blank"> Fighting COVID-19 with AI: efforts and lessons from China</a>. Global Times, March 7th, 2020.</li>
            </ul>
            <ul>
              <li>Yi Zeng, Enmeng Lu, Yinqian Sun, Ruochen Tian. <a href="https://arxiv.org/abs/1909.12935" target="_blank">Responsible Facial Recognition and Beyond</a>. 2019.</li>
            </ul>
            <ul>
              <li>Yi Zeng, Enmeng Lu, Cunqing Huangfu. <a href="http://ceur-ws.org/Vol-2301/paper_15.pdf" target="_blank">Linking Artificial Intelligence Principles</a>. The AAAI 2019 Safe Artificial Intelligence (AAAI SafeAI-2019) Workshop, January 27, 2019.</li>
            </ul>
            <ul>
              <li><strong>Principles and Specifications </strong></li>
            </ul>

            <ul>
              <li><a href="https://ai-for-sdgs.academy/principles-on-ai-for-climate-action" target="_blank">Principles on AI for Climate Actions</a>, 2022. [Yi Zeng, as the lead author, with contributions from Cunqing Huangfu, Kang Sun, Yang Yu, Emma Ruttkamp-Bloem, Mark Findlay, Christoph
                L&uuml;tge, Helen Meng, etc.]
              </li>
            </ul>
            <ul>
              <li><a href="https://ai-ethics-and-governance.institute/2021/09/27/the-ethical-norms-for-the-new-generation-artificial-intelligence-china/">Ethical Norms for the New Generation Artificial Intelligence</a>, 2021. [Yi Zeng as one of the authors and board members for national governance
                committee of new generation AI]
              </li>
            </ul>
            <ul>
              <li><a href="https://unesdoc.unesco.org/ark:/48223/pf0000379920#page=14">Recommendation of AI Ethics, UNESCO</a>,&nbsp;2021. [Yi Zeng as one of the members of the UNESCO Adhoc Expert Group on AI Ethics]</li>
            </ul>
            <ul>
              <li><a href="https://www.who.int/publications-detail-redirect/9789240029200">WHO Guidance on AI Ethics and Governance for Health</a>, 2021 [Yi Zeng as one of the members for the WHO Expert Group on AI Ethics and Governance for Health]</li>
            </ul>
            <ul>
              <li><a href="https://www.who.int/publications/i/item/WHO-2019-nCoV-Ethics_Contact_tracing_apps-2020.1">Ethical considerations to guide the use of digital proximity tracking technologies for COVID-19 contact tracing</a>, World Health Organization (WHO), 2020. [Yi Zeng as one of the
                members for the WHO Expert Group on AI Ethics and Governance for Health.
              </li>
            </ul>
            <ul>
              <li><a rel="noopener" href="http://www.chinadaily.com.cn/a/201906/17/WS5d07486ba3103dbf14328ab7.html" target="_blank">Governance Principles for the New Generation Artificial Intelligence</a>, 2019. [Yi Zeng as one of the main authors and board members for the national governance
                committee of new generation AI]
              </li>
            </ul>
            <ul>
              <li><a href="https://ai-ethics-and-governance.institute/artificial-intelligence-for-children-beijing-principles/">AI for Children: Beijing Principles</a>, 2020<a rel="noopener" href="https://www.baai.ac.cn/ai-for-children.html" target="_blank">.</a>&nbsp;[Yi Zeng, Kang Sun, Enmeng Lu
                as the authors and endorsed by the academic and industrial community]
              </li>
            </ul>
            <ul>
              <li><a href="http://ai-ethics-and-governance.institute/beijing-artificial-intelligence-principles">Beijing AI Principles</a>, 2019. [Yi Zeng as the lead author, with participation from Enmeng Lu, and endorsed by the academic and industrial community]</li>
            </ul>
            <ul>
              <li>Harmonious Artificial Intelligence Principles, 2018. [Yi Zeng as the author]</li>
            </ul>
          </div>
        </div>
      </div>
          </div>
          );
          };

          export default SelectedPublications;